import { combineReducers } from 'redux';
import workSessions from './workSessions/workSessionsReducer';
import user from './user/userReducer';

export default combineReducers({
  workSessions,
  user,
});
